<template>
  <div>
    <vx-card class="mt-base mb-5" :title="activityTitle">
      <p class="mb-5">
        Patient-centred care is all about treating a person with dignity and respect and involving
        them in all decisions about their health. This type of care is also called ‘person-centred
        care’, and is an approach that involves:
      </p>
      <ul class="default-list">
        <li>Treating the person with dignity, respect and compassion</li>
        <li>
          Communicating and coordinating care between their appointments and different services over
          time, such as when making a referral from their GP to a specialist
        </li>
        <li>Inviting the patient's family members to participate in decision-making</li>
        <li>sharing their care between a community health service and a hospital</li>
        <li>Tailoring the care to suit their needs and what they want to achieve</li>
        <li>Supporting them to understand and learn about their health</li>
        <li>Helping them find ways to get better, look after themselves and stay independent</li>
        <li>Involving them in their healthcare decisions at all times</li>
      </ul>

      <p class="mb-5">
        Family-centred care is the delivery of health care based on partnerships between patients,
        families and all those involved in the care of the child and family. It is The process of
        actively involving children, adolescents, families and communities in their own health care.
      </p>
      <p class="mb-5">
        In this activity, you will consider 2 patients that have been admitted to hospital for a
        broken ankle under different circumstances described below. Using the patient-centred care
        approach, read their situation and answer the questions below. In what way could
        patient-centred care be important to them?
      </p>

      <div v-for="(question, index) in questions" :key="index">
        <div v-html="question.question" />
        <radio-buttons-wrapper
          v-model="data['question' + index]"
          :index="index + 1"
          :question="question"
          :is-editable="isEditable"
          show-question="false"
        />
      </div>

      <p class="mb-5">Now answer the following questions:</p>
      <p class="mb-5">
        1) Why do you think is it important to involve a patient in their healthcare decisions at
        all times?
      </p>
      <textarea-block v-model="data.question3" :editable="isEditable" />

      <p class="mb-5">2) In your own words, what is family-centered care?</p>
      <textarea-block v-model="data.question4" :editable="isEditable" />

      <p class="mb-5">3) Should a child be actively involved in their own health care?</p>
      <switch-block v-model="data.question5" :editable="isEditable" />

      <p class="mb-5">
        4) What are 3 things you can do to make a patient feel involved in their healthcare
        decisions? E.g treating the person with dignity.
      </p>
      <text-block v-model="data.question6" :editable="isEditable" />

      <save-buttons :is-editable="isEditable" @save="save" />
    </vx-card>
  </div>
</template>

<script>
import methods from '@/views/WorkExperiences/components/activity_js/methods';
import computed from '@/views/WorkExperiences/components/activity_js/computed';
import inject from '@/views/WorkExperiences/components/activity_js/inject';
import RadioButtonsWrapper from '@/views/WorkExperiences/components/ActivitiesBlocks/RadioButtonsWrapper';
export default {
  components: { RadioButtonsWrapper },
  data() {
    return {
      questions: {
        1: {
          question: `<h4 class="mb-5">Patient 1</h4>
<p class="mb-2">A 6 year old girl has just been admitted with a broken ankle and is finding it extremely challenging being in a hospital environment. She is in a lot of pain, crying, and is generally very distressed. In this situation you would (click the appropriate answer):</p>`,
          answers: [
            {
              val: 1,
              answer:
                'a) You can see this is causing the patient distress. You calmly reassure the patient that she is in a safe place and tell her in age-appropriate terms that her ankle is broken, that they can give her pain relief and what will happen next.  You then talk to her Mum and explain the situation and that she will have the opportunity to discuss this further with the doctor. You explain that you will provide her with post-care information that will help her with any concerns.',
              correct: true,
            },
            {
              val: 2,
              answer:
                "b) You see the patient's anxiety but take into consideration that perhaps she doesn't understand all that is going on since she is so young. You ask to speak with the patient's Mum privately and take the time to go over everything with her Mum and don’t involve the young patient.",
              correct: false,
            },
            {
              val: 3,
              answer:
                'c)\tYou try to calm the young patient down by asking her what she would like to know. You tell her every detail about the breaks in her ankle, surgery she might need and how long it will take to recover. Mum listened in but as she isn’t the patient, you won’t need to run her through the information.',
              correct: false,
            },
          ],
        },
        2: {
          question: `<h4 class="mb-5">Patient 2</h4>
<p class="mb-2">A 44 year old woman has been in hospital for 4 days due to severely fracturing several bones in both ankles. She wants to go home but will have to stay at least another few days. English is the patient’s second language and sometimes she struggles to understand specific medical terms. In this situation you would (click the appropriate answer):</p>`,
          answers: [
            {
              val: 4,
              answer:
                'a) Take into consideration that perhaps she doesn’t understand all that is going on since she is here alone. Take the time to go over everything with her again.',
              correct: false,
            },
            {
              val: 5,
              answer:
                'b) Explain to the patient that a scar is the last thing she should be concerned about. Explain it to her in a place away from others and ask her if she has any more important questions.',
              correct: true,
            },
            {
              val: 6,
              answer:
                'c) You can see this is causing the patient anxiety. You reassure the patient that any scar will be minimal and fade over time (if this is the prognosis) and that she will have the opportunity to discuss this further with the doctor. Explain also that you will provide her with post-care information that will help her with her concerns.',
              correct: false,
            },
          ],
        },
      },
      answers_correct: {
        question1: true,
        question2: true,
      },
      correct_answers: {
        question1: 1,
        question2: 5,
      },
    };
  },
  methods: methods,
  computed: computed,
  inject: inject,
  mounted() {
    if (typeof this.uploaded_files !== 'undefined') {
      for (let i = 1; i <= Object.keys(this.uploaded_files).length; i++) {
        if (typeof this.data['uploaded_file_' + i] !== 'undefined') {
          this.uploaded_files['uploaded_file_' + i] = this.data['uploaded_file_' + i];
        }
      }
    }
  },
};
</script>
